export default "__VITE_ASSET__B5VlpM93__"